import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Paper,
  Box,
  Container,
  CircularProgress,
  Backdrop,
  Typography
} from '@mui/material';
import { AccountCircle, School, Group } from '@mui/icons-material';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import Popup from '../components/Popup';
import { motion } from 'framer-motion';

const ChooseUser = () => {
  const navigate = useNavigate()

  const { status, currentUser, currentRole } = useSelector(state => state.user);;

  const [loader, setLoader] = useState(false)
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");

  const navigateHandler = (user) => {
    if (user === "Admin") {
      navigate('/Adminlogin');
    }
    else if (user === "Student") {
      navigate('/Studentlogin');
    }
    else if (user === "Teacher") {
      navigate('/Teacherlogin');
    }
  }

  useEffect(() => {
    if (status === 'success' || currentUser !== null) {
      if (currentRole === 'Admin') {
        navigate('/Admin/dashboard');
      }
      else if (currentRole === 'Student') {
        navigate('/Student/dashboard');
      } else if (currentRole === 'Teacher') {
        navigate('/Teacher/dashboard');
      }
    }
    else if (status === 'error') {
      setLoader(false)
      setMessage("Network Error")
      setShowPopup(true)
    }
  }, [status, currentRole, navigate, currentUser]);

  return (
    <StyledContainer>
      <Container>
        <Typography variant="h3" sx={{ textAlign: 'center', color: '#fff', mb: 6, fontWeight: 'bold' }}>
          Choose Your Role
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigateHandler("Admin")}>
              <StyledPaper elevation={6}>
                <Box mb={2}>
                  <AccountCircle sx={{ fontSize: 80, color: "#FF9933" }} />
                </Box>
                <StyledTypography>
                  Administrator
                </StyledTypography>
                <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Manage the entire institute, handle users, and oversee operations.
                </Typography>
              </StyledPaper>
            </motion.div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
             <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigateHandler("Student")}>
              <StyledPaper elevation={6}>
                <Box mb={2}>
                  <School sx={{ fontSize: 80, color: "#FF9933" }} />
                </Box>
                <StyledTypography>
                  Student
                </StyledTypography>
                <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Access academic records, pay fees, and track attendance.
                </Typography>
              </StyledPaper>
            </motion.div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigateHandler("Teacher")}>
              <StyledPaper elevation={6}>
                <Box mb={2}>
                  <Group sx={{ fontSize: 80, color: "#FF9933" }} />
                </Box>
                <StyledTypography>
                  Faculty
                </StyledTypography>
                <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Manage classes, mark attendance, and evaluate performance.
                </Typography>
              </StyledPaper>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
        Please Wait
      </Backdrop>
      <Popup message={message} setShowPopup={setShowPopup} showPopup={showPopup} />
    </StyledContainer>
  );
};

export default ChooseUser;

const StyledContainer = styled.div`
  background: #0A192F;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 2rem;
`;

const StyledPaper = styled(Paper)`
  padding: 40px 20px;
  text-align: center;
  background-color: #112240 !important;
  color: white !important;
  cursor: pointer;
  border-radius: 16px !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background-color: #233554 !important;
    border-color: #FF9933;
    box-shadow: 0 10px 30px -10px rgba(255, 153, 51, 0.3) !important;
  }
`;

const StyledTypography = styled.h2`
  margin-bottom: 15px;
  font-weight: 600;
  color: #fff;
`;